export default [
    {
        path: '/claim/list/:filter?',
        name: 'claim_list',
        component: () => import('@src/claim/claim-list.vue'),
        meta: {
            title: 'Alle Reklamationen',
            role: 'ROLE_CLAIM',
        },
    },
    {
        path: '/claim/list-current-user/:filter?',
        name: 'claim_list_current_user',
        component: () => import('@src/claim/claim-list-current-user.vue'),
        meta: {
            title: 'Meine Reklamationen',
            role: 'ROLE_CLAIM',
        },
    },
    {
        path: '/claim/list-open/:filter?',
        name: 'claim_list_open',
        component: () => import('@src/claim/claim-list-open.vue'),
        meta: {
            title: 'Offene Reklamationen',
            role: 'ROLE_CLAIM',
        },
    },
    {
        path: '/claim/create',
        name: 'claim_create',
        component: () => import('@src/claim/claim-create.vue'),
        meta: {
            title: 'Reklamation erstellen',
            role: 'ROLE_CLAIM',
        },
    },
    {
        path: '/claim/edit/:id',
        name: 'claim_edit',
        component: () => import('@src/claim/claim-edit.vue'),
        props({ params }: { params: { id: string } }) {
            return {
                id: Number(params.id),
            };
        },
        meta: {
            title: 'Reklamation bearbeiten',
            role: 'ROLE_CLAIM',
        },
    },
    {
        path: '/claim/settings/reduction',
        name: 'claim_reduction_settings',
        component: () => import('@src/claim/settings/claim-reduction-settings.vue'),
        meta: {
            title: 'Minderungseinstellungen',
            role: 'ROLE_EDIT_CLAIM_SETTINGS',
        },
    },
    {
        path: '/claim/processing-states',
        name: 'claim_processing_states',
        component: () => import('@src/claim/components/claim-processing-states.vue'),
        meta: {
            title: 'Bearbeitungsstände verwalten',
            role: 'ROLE_CLAIM_PROCESSING_STATES_EDIT',
        },
    },
    {
        path: '/claim/list-tags/:filter?',
        name: 'claim_list_tags',
        component: () => import('@src/claim/components/claim-tags/claim-tags-list.vue'),
        meta: {
            title: 'Tags',
            role: 'ROLE_LIST_CLAIM_TAGS',
        },
    },
    {
        path: '/claim/tags/create',
        name: 'claim_tags_create',
        component: () => import('@src/claim/components/claim-tags/claim-tag-create.vue'),
        meta: {
            title: 'Tag erstellen',
            role: 'ROLE_EDIT_CLAIM_TAGS',
        },
    },
    {
        path: '/claim/tags/edit/:id',
        name: 'claim_tags_edit',
        props({ params }: { params: { id: string } }) {
            return {
                id: Number(params.id),
            };
        },
        component: () => import('@src/claim/components/claim-tags/claim-tag-edit.vue'),
        meta: {
            title: 'Tag bearbeiten',
            role: 'ROLE_EDIT_CLAIM_TAGS',
        },
    },
];
